import React from 'react';
import PropTypes from 'prop-types';
import './StepBox.scss';

const StepBox = ({className, steps, activeIndex, ...props}) => (
  <ul className={`step-box ${className}`} {...props}>
    {steps &&
      steps.map((step, idx) => (
        <li key={idx} className={activeIndex === idx ? 'active' : ''}>
          <span>{(idx + 1).toString().padStart(2, '0')}</span>
          {step}
        </li>
      ))}
  </ul>
);

StepBox.propTypes = {
  steps: PropTypes.array.isRequired,
  activeIndex: PropTypes.number.isRequired,
};

export default StepBox;
